import { render, staticRenderFns } from "./ModalInfoExtrato.vue?vue&type=template&id=12117032"
import script from "./ModalInfoExtrato.vue?vue&type=script&lang=js"
export * from "./ModalInfoExtrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports